import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { popularCities } from '../utils/cities';
import { HomePage } from './HomePage';

export const CityPage: React.FC = () => {
  const { cityName } = useParams<{ cityName: string }>();
  const navigate = useNavigate();
  
  const city = popularCities.find(c => encodeURIComponent(c.name) === cityName);
  
  React.useEffect(() => {
    if (!city) {
      navigate('/', { replace: true });
    }
  }, [city, navigate]);

  if (!city) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>מה ללבוש היום ב{city.name}? - המלצות לבוש לפי מזג האוויר</title>
        <meta 
          name="description" 
          content={`קבלו המלצות לבוש מותאמות אישית לפי מזג האוויר ב${city.name}. תחזית מזג אוויר והמלצות לבוש יומיות.`} 
        />
        <meta 
          name="keywords" 
          content={`מזג אוויר ${city.name}, המלצות לבוש ${city.name}, תחזית מזג אוויר ${city.name}, מה ללבוש ${city.name}, ישראל`} 
        />
        <link rel="canonical" href={`https://weather.automatzia.co.il/${encodeURIComponent(city.name)}`} />
        <meta property="og:title" content={`מה ללבוש היום ב${city.name}? - המלצות לבוש לפי מזג האוויר`} />
        <meta property="og:description" content={`קבלו המלצות לבוש מותאמות אישית לפי מזג האוויר ב${city.name}. תחזית מזג אוויר והמלצות לבוש יומיות.`} />
        <meta property="og:url" content={`https://weather.automatzia.co.il/${encodeURIComponent(city.name)}`} />
        
        {/* Additional meta tags for city pages */}
        <meta name="geo.placename" content={city.name} />
        <meta name="geo.position" content={`${city.lat};${city.lon}`} />
        <meta name="ICBM" content={`${city.lat}, ${city.lon}`} />
        
        {/* JSON-LD for city pages */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `מה ללבוש היום ב${city.name}?`,
            "description": `תחזית מזג אוויר והמלצות לבוש ל${city.name}`,
            "url": `https://weather.automatzia.co.il/${encodeURIComponent(city.name)}`,
            "inLanguage": "he-IL",
            "isPartOf": {
              "@type": "WebSite",
              "name": "מה ללבוש היום?",
              "url": "https://weather.automatzia.co.il"
            },
            "about": {
              "@type": "City",
              "name": city.name,
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": city.lat,
                "longitude": city.lon
              }
            }
          })}
        </script>
      </Helmet>

      <HomePage />
    </>
  );
};